/**
 * Generated a secret and base32 encode it
 *
 * @returns The secret as base32
 */
export function genTotpSecret() {
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
    const array = new Uint8Array(24);
    self.crypto.getRandomValues(array);
    let ret = "";
    for (let i = 0; i < array.length; i++) ret += alphabet[array[i] >> 4] + alphabet[array[i] & 0xf];
    return ret;
}

/**
 * Helper method to format the url
 *
 * @param label The user supplied label
 * @param secret The secret
 *
 * @returns The formatted string
 */
export function genTotpUrl(label: string, secret: string) {
    return `otpauth://totp/${encodeURIComponent(label)}?secret=${encodeURIComponent(secret)}&issuer=${encodeURIComponent("Trufflepig Forensics")}`;
}
